// 路由 + 顶层 providers
// 新版:用 @fluentui/react-components 替代 antd + fluent-kit
// oauth_only 模式:不注册 /register 路由(避免输错 URL 进到注册页;
//  RegisterPage 内部也会做一次 Navigate to /login 兜底,后端 403 兜底)。
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { AdminRoute } from '@/components/AdminRoute';
import { ROUTES } from '@/routes';
import { LoginPage } from '@/pages/LoginPage';
import { RegisterPage } from '@/pages/RegisterPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { ExplorePage } from '@/pages/ExplorePage';
import { SettingsPage } from '@/pages/SettingsPage';
import { UserManagementPage } from '@/pages/UserManagementPage';
import { AdminRepoManagementPage } from '@/pages/AdminRepoManagementPage';
import { AdminBackupPage } from '@/pages/AdminBackupPage';
import { SettingsHubPage } from '@/pages/SettingsHubPage';
import { StatsPage } from '@/pages/StatsPage';
import { OAuthCallbackPage } from '@/pages/OAuthCallbackPage';
import { getAuthMode } from '@/lib/authMode';

export function App() {
  const mode = getAuthMode();
  const isOauthOnly = mode === 'oauth_only';
  console.log('[gitman-dbg] <App/> render, authMode=', mode, 'isOauthOnly=', isOauthOnly);
  return (
    <Routes>
      {/* 公开页 */}
      <Route path={ROUTES.login} element={<LoginPage />} />
      {/* oauth_only 模式:不暴露 /register;命中时由 fallback 走 Navigate 到 home。 */}
      {!isOauthOnly && (
        <Route path={ROUTES.register} element={<RegisterPage />} />
      )}
      {/* OAuth2 标准授权码流程:IdP 回跳落地页(公开,兑换 code 后得到 token) */}
      <Route path={ROUTES.oauthCallback} element={<OAuthCallbackPage />} />

      {/* Layout 包裹的页 */}
      <Route element={<Layout />}>
        {/* 默认主页:统计仪表盘(需登录) */}
        <Route
          path={ROUTES.home}
          element={
            <ProtectedRoute>
              <StatsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path={ROUTES.explore}
          element={
            <ProtectedRoute>
              <ExplorePage />
            </ProtectedRoute>
          }
        />

        {/* 需登录 */}
        <Route
          path={ROUTES.dashboard}
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.settings}
          element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.adminUsers}
          element={
            <ProtectedRoute>
              <UserManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.adminRepos}
          element={
            <ProtectedRoute>
              <AdminRepoManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.adminBackups}
          element={
            <ProtectedRoute>
              <AdminBackupPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.adminSettings}
          element={
            <AdminRoute>
              <SettingsHubPage />
            </AdminRoute>
          }
        />
      </Route>

      {/* fallback */}
      <Route path="*" element={<Navigate to={ROUTES.home} replace />} />
    </Routes>
  );
}
